export function isPatientVideoRole(userRole) {
  const normalizedUserRole = String(userRole || '').toLowerCase()
  return ['user', 'consumer', 'patient', 'enduser'].includes(normalizedUserRole)
}
